import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { UIThemeNamesType } from "@/app_redux/reducers/reducer_interface";
import { setUITheme } from "@/app_redux/reducers/slices/ui_states_slice";
import { useEffect } from "react";
import { useConfiguration } from "../useConfiguration";

type IThemeClassesMap = {
  [key in UIThemeNamesType]: string;
};

export const THEME_MAP: IThemeClassesMap = {
  KIWI: "invert hue-rotate-15",
  PEPPER: "invert hue-rotate-30",
  PHANTOM: "hue-rotate-60",
  PLUTO: "hue-rotate-90",
  SIMBA: "hue-rotate-180",
  VETIC: "",
};

export const useUITheme = () => {
  const UITheme = useAppSelector((state) => state.root.UIStates.theme);
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();

  const checkThemeInLocalStorage = () => {
    if (localStorage.getItem(configuration.localStorage.UI_THEME.key)) {
      return true;
    }
    return false;
  };

  const setTheme = (theme: UIThemeNamesType) => {
    dispatch(setUITheme(theme));
    localStorage.setItem(configuration.localStorage.UI_THEME.key, theme);
  };

  const getTheme = (): UIThemeNamesType => {
    if (checkThemeInLocalStorage()) {
      return localStorage.getItem(configuration.localStorage.UI_THEME.key) as UIThemeNamesType;
    } else {
      return UITheme;
    }
  };

  useEffect(() => {
    if (checkThemeInLocalStorage()) {
      setTheme(getTheme());
    } else {
      localStorage.setItem(configuration.localStorage.UI_THEME.key, "VETIC");
    }
  }, []);

  return {
    theme: UITheme,
    setTheme,
  };
};
